import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation(['common']);

  const resourceLinks = [
    { label: t('common:nav.categories'), url: 'https://kaspreadsheet.com' },
    { label: t('common:nav.guides'), url: 'https://kaspreadsheet.com' },
    { label: t('common:nav.qc'), url: 'https://kaspreadsheet.com' },
    { label: t('common:nav.shipping'), url: 'https://kaspreadsheet.com' },
    { label: t('common:nav.reviews'), url: 'https://kaspreadsheet.com' },
    { label: t('common:nav.safety'), url: 'https://kaspreadsheet.com' },
  ];

  const legalLinks = [
    { label: t('common:footer.privacy'), url: '#' },
    { label: t('common:footer.terms'), url: '#' },
    { label: t('common:footer.editorial'), url: '#' },
  ];

  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 font-bold text-lg tracking-tight text-gray-900 mb-4">
              <span className="w-8 h-8 rounded-lg bg-emerald-600 flex items-center justify-center text-white text-sm font-extrabold">
                C
              </span>
              {t('common:site.name')}
            </div>
            <p className="text-sm text-gray-500 leading-relaxed mb-4">
              {t('common:site.tagline')}
            </p>
            <p className="text-xs text-gray-400 leading-relaxed">
              {t('common:footer.disclaimer')}
            </p>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              {t('common:footer.resources')}
            </h3>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-gray-600 hover:text-emerald-700 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4">
              {t('common:footer.legal')}
            </h3>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.url}
                    className="text-sm text-gray-600 hover:text-emerald-700 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-400">
            {t('common:footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-gray-400">{t('common:lang.pt')}</span>
            <span className="text-xs text-gray-300">|</span>
            <span className="text-xs text-gray-400">{t('common:lang.de')}</span>
            <span className="text-xs text-gray-300">|</span>
            <span className="text-xs text-gray-400">{t('common:lang.en')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}